import { cn } from "@shared/ui";
import { ReactNode } from "react";

type StepFooterProps = {
  children: ReactNode;
  className?: string;
};

const StepFooter = ({ children, className }: StepFooterProps) => (
  <div
    className={cn(
      // Sides match the content's space-6; the bottom also clears the home indicator.
      "flex shrink-0 flex-col gap-2 border-t border-subtle bg-surface px-6 pt-4 sm:pt-6",
      "pb-[max(theme(spacing.4),env(safe-area-inset-bottom))] sm:pb-[max(theme(spacing.6),env(safe-area-inset-bottom))]",
      className
    )}
  >
    {children}
  </div>
);

export default StepFooter;
